<template>
  <div class="home">
    <com-returntop></com-returntop>
   <swiper :options="swiperOption">
      <swiper-slide>
        <img
          class="home-swiper-img"
          src="https://bernouly.oss-cn-beijing.aliyuncs.com/home/banner1.png"
          alt
        />
      </swiper-slide>
      <swiper-slide>
        <a href="http://www.bernouly.com/production/synergy">
          <img
            class="home-swiper-img"
            src="https://bernouly.oss-cn-beijing.aliyuncs.com/home/xietongyuren.png"
            alt
          />
        </a>
      </swiper-slide>
      <swiper-slide>
        <img
          class="home-swiper-img"
          src="https://bernouly.oss-cn-beijing.aliyuncs.com/home/banner3.png"
          alt
        />
      </swiper-slide>
      <swiper-slide>
        <img
          class="home-swiper-img"
          src="https://bernouly.oss-cn-beijing.aliyuncs.com/home/banner4.png"
          alt
        />
      </swiper-slide>
      <swiper-slide>
        <img
          class="home-swiper-img"
          src="https://bernouly.oss-cn-beijing.aliyuncs.com/home/banner5.png"
          alt
        />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div class="container">
      <div class="page">
        <div class="page_up">
          <!-- 仿真产品轮播图模块 -->
          <div class="up_left">
            <div class="text">
              <p>
                仿真产品 &nbsp;
                <span>Simulation Products</span>
              </p>
            </div>
            <div class="img_con">
              <div>
                <a :href="imgList[now].pageToUrl">
                  <img :src="imgList[now].imgSrc" />
                </a>
                <div id="modal">
                  <span id="modal_des">{{ textList[now] }}</span>
                </div>
              </div>

              <div class="circle">
                <ul
                  v-for="(item, index) in imgList"
                  :key="index"
                  @click="handlePre(index)"
                >
                  <li :class="now == index ? 'current' : 'box'"></li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 公司动态模块 -->
          <div class="up_right">
            <div class="title1">
              <p>
                公司动态&nbsp;
                <span>Company Dynamics</span>
                <span class="more" style="margin-right: 40px">
                  <router-link to="/active">更多></router-link>
                </span>
              </p>
            </div>
            <div class="up_right_con">
              <img
                :src="dynamicsImg"
                width="256px"
                height="146px"
              />
              <div style="margin-left: 18px">
                <div

                  v-for="(item, index) in titleList"
                  :key="index"
                  @mouseenter="enter(index)"
                  @mouseleave="leave()"
                  @click="toDetail(index)"
                >
                  <div class="title-right">
                    <div class="title-title">{{ item.name }}</div>
                    <div class="title-brief">{{ item.brief }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="up_right_bottom">
              <div
                class="_title"
                v-for="(item, index) in titleList1"
                :key="index"
                @mouseenter="enter(index)"
                @mouseleave="leave()"
                @click="toDetail1(index)"
              >
                <div class="tit_name">{{ item.name }}</div>
                <div class="tit_time">
                  {{ item.tm.Y }}.{{ item.tm.M }}.{{ item.tm.D }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page_down">
          <!-- 1+X证书模块 -->
          <div class="down_left">
            <div class="title2">
              <p>
                评价基地&nbsp;
                <span>Evaluation Base</span>
                <span class="more" style="margin-right: 40px">
                  <router-link to="/evalStandard">更多></router-link>
                </span>
              </p>
            </div>
            <div class="down_text">
              <div
                class="_title1"
                v-for="(item, index) in titleList2"
                :key="index"
                @mouseenter="enter(index)"
                @mouseleave="leave()"
                @click="toDetail2(index)"
              >
                <div class="tit_name1">{{ item.name }}</div>
                <div class="tit_time1">
                  {{ item.tm.Y }}.{{ item.tm.M }}.{{ item.tm.D }}
                </div>
                
                  
                
              </div>
            </div>
          </div>
          <!-- 1+X证书查询快捷入口模块 -->
          <div class="down_right">
            <div class="title3">
              <p>
                快捷入口&nbsp;
                <span>Quick Entry</span>
              </p>
            </div>

            <div class="quick_entry">
              <a
                href="http://jnzscx.cec.org.cn/"
                target="_blank"
                rel="noopener noreferrer"
                class="quick_entry_item"
                @mouseenter="setQuickEntryHover('zhengshu', true)"
                @mouseleave="setQuickEntryHover('zhengshu', false)"
              >
                <img
                  :src="quickEntryHover.zhengshu ? zhengshuActiveImg : zhengshuImg"
                  class="quick_entry_icon"
                  alt="中电联证书查询入口"
                />
                <div class="quick_info" style="text-align: center;">
                  中电联证书查询入口
                </div>
              </a>

              <a
                href="https://www.epta.org.cn/home"
                target="_blank"
                rel="noopener noreferrer"
                class="quick_entry_item"
                @mouseenter="setQuickEntryHover('search', true)"
                @mouseleave="setQuickEntryHover('search', false)"
              >
                <img
                  :src="quickEntryHover.search ? searchActiveImg : searchImg"
                  class="quick_entry_icon"
                  alt="电力行业人才发展服务平台"
                />
                <div
                  class="quick_info"
                  style="text-align: center; font-size: 12px;"
                >
                  电力行业人才发展服务平台
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Article, timestampToTime } from "../services/article";
import comNotice from "@/components/notice";
import comReturntop from "@/components/returntop";
import zhengshuImg from "../assets/home/zhengshu.png";
import zhengshuActiveImg from "../assets/home/zhengshu_active.png";
import searchImg from "../assets/home/search.png";
import searchActiveImg from "../assets/home/search_active.png";
let timer = null;
export default {
  components: {
    comNotice,
    comReturntop,
  },
  data() {
    return {
      zhengshuImg,
      zhengshuActiveImg,
      searchImg,
      searchActiveImg,
      quickEntryHover: {
        zhengshu: false,
        search: false,
      },
      titleList: [],
      dynamicsImg:'',
      titleList1: [],
      titleList2: [],
      styleFlag: -1,
      imgList: [
        {
          imgSrc:
            "https://bernouly.oss-cn-beijing.aliyuncs.com/home/01xinnengyuanfangzhen.png",
          id: 1,
          pageToUrl: "https://www.bernouly.com/product?id=0",
        },
        {
          imgSrc:
            "https://bernouly.oss-cn-beijing.aliyuncs.com/home/02dianlifangzhen.png",
          id: 2,
          pageToUrl: "https://www.bernouly.com/product?id=1",
        },
        {
          imgSrc:
            "https://bernouly.oss-cn-beijing.aliyuncs.com/home/03huanbaofangzhen.png",
          id: 3,
          pageToUrl: "https://www.bernouly.com/product?id=2",
        },
        {
          imgSrc:
            "https://bernouly.oss-cn-beijing.aliyuncs.com/home/04jiancaifangzhen.png",
          id: 4,
          pageToUrl: "https://www.bernouly.com/product?id=3",
        },
        {
          imgSrc:
            "https://bernouly.oss-cn-beijing.aliyuncs.com/home/05huagongjishu.png",
          id: 5,
          pageToUrl: "https://www.bernouly.com/product?id=4",
        },
        {
          imgSrc:
            "https://bernouly.oss-cn-beijing.aliyuncs.com/home/06kechengziyuan.png",
          id: 6,
          pageToUrl: "https://www.bernouly.com/product?id=5",
        },
        {
          imgSrc:
            "https://bernouly.oss-cn-beijing.aliyuncs.com/home/07xunishiyan.png",
          id: 7,
          pageToUrl: "https://www.bernouly.com/product?id=6",
        },
        {
          imgSrc:
            "https://bernouly.oss-cn-beijing.aliyuncs.com/home/08jianmoruanjian.png",
          id: 7,
          pageToUrl: "https://www.bernouly.com/product?id=7",
        },
      ],
      textList: [
        "新能源仿真",
        "电力仿真",
        "环保仿真",
        "建材仿真",
        "化工技术",
        "课程资源",
        "虚拟实验",
        "建模软件",
      ],
      currentIndex: 0, //默认显示图片
      now: 0, // 图片的索引
      timer: null, //定时器
      imgSrc: "",
      imgWidth: 0,
      left: 0,

      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 允许点击小圆点跳转
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false, // 手动切换之后继续自动轮播
        },
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  watch: {},
  computed: {
    // 计算当前图片的位置
    nextIndex() {
      // 如果当前index等等于数组length-1 就return0 否则就当前index加1
      if (this.now == this.imgList.length - 1) {
        return 0;
      } else {
        return this.now + 1;
      }
    },
  },
  destroyed() {},
  mounted() {
    // 执行定时器
    this.autoPlay();
    this.article();
    this.article1();
    this.article2();
  },
  methods: {
    setQuickEntryHover(key, hovered) {
      this.quickEntryHover[key] = hovered;
    },
    // 轮播图的定时器
    autoPlay() {
      this.timer = setInterval(() => {
        this.handlePre(this.nextIndex);
      }, 3000);
    },
    toActive(id) {
      this.$router.push({
        path: "/active",
        query: {
          id,
        },
      });
    },
    handlePre(preIndex) {
      this.now = preIndex;
    },
    //鼠标悬浮事件-修改文章标题样式
    enter(index) {
      this.styleFlag = index;
    },
    //鼠标离开事件-修改文章标题样式
    leave() {
      this.styleFlag = -1;
    },
    // 定义公司动态置顶文章的查询方法
    article() {
      this.titleList = [];
      let titleList = [];
      Article({
        category_id: 80,
        top: 1,
        pageSize: 1,
        page: 1,
      }).then((res2) => {
        if (res2.items.length > 0) {
          res2.items.forEach((citem) => {
            //时间格式处理   原有逻辑↓
            //let tm = timestampToTime(citem.release_time);
            //适配java后端需要做时间转换
            let tm = timestampToTime(
              new Date(citem.release_time).getTime() / 1000
            );
            citem.tm = tm;
            titleList.push(citem);
          });
          this.titleList = titleList;
          this.dynamicsImg = res2.items[0].image;
        }
      });
    },
    article1() {
      this.titleList1 = [];
      let titleList = [];
      Article({
        category_id: 80,
        pageSize: 4,
        page: 1,
      }).then((res2) => {
        if (res2.items.length > 0) {
          res2.items.forEach((citem) => {
            //时间格式处理   原有逻辑↓
            //let tm = timestampToTime(citem.release_time);
            //适配java后端需要做时间转换
            let tm = timestampToTime(
              new Date(citem.release_time).getTime() / 1000
            );
            citem.tm = tm;
            titleList.push(citem);
          });
          this.titleList1 = titleList;
        }
      });
    },
    article2() {
      this.titleList2 = [];
      let titleList = [];
      Article({
        type: 1,
        pageSize: 6,
        page: 1,
      }).then((res2) => {
        if (res2.items.length > 0) {
          res2.items.forEach((citem) => {
            //时间格式处理   原有逻辑↓
            //let tm = timestampToTime(citem.release_time);
            //适配java后端需要做时间转换
            let tm = timestampToTime(
              new Date(citem.release_time).getTime() / 1000
            );
            citem.tm = tm;
            titleList.push(citem);
          });
          this.titleList2 = titleList;
        }
      });
    },
    // 短正文且有附件时直接打开附件；否则进详情（避免 attachment 为 null 时跳到 /null）
    openArticle(item, query = {}) {
      const content = item.content || "";
      if (content.length < 100 && item.attachment) {
        window.open(item.attachment, "_blank");
        return;
      }
      this.$router.push({
        path: "/certificate-active",
        query: {
          id: item.id,
          ...query,
        },
      });
    },
    // 文章点击跳转文章详情页
    toDetail(index) {
      this.openArticle(this.titleList[index], { top: 1 });
    },
    toDetail1(index) {
      this.openArticle(this.titleList1[index]);
    },
    toDetail2(index) {
      this.openArticle(this.titleList2[index]);
    },
  },
};
</script>
<style scoped>
.swiper-pagination div {
  background: #fff;
  width: 26px;
  height: 14px;
  text-align: left;
}

.home-swiper-img {
  width: 100%;
}

/* 首页改版新增样式 */
.container {
  width: 100%;
  height: 728px;
  background: #f2f2f2;
  align-items: center;
}
.page {
  width: 1204px;
  margin: auto auto;
  height: 645px;
}
.page_up {
  display: flex;
  width: 1204px;
  height: 385px;
  margin-top: 33px;
}
.up_left {
  width: 626px;
  height: 385px;
  background: #ffffff;
}
.up_right {
  width: 565px;
  height: 385px;
  background: #ffffff;
  margin-left: 12px;
}
.up_right_con {
  display: flex;
  margin-top: 21px;
  margin-left: 30px;
  margin-right: 32px;
}

.right_con {
  list-style: disc;
  color: #333333;
  font-weight: 400;
  font-size: 14px;
  width: 375px;
  white-space: nowrap;
  word-break: normal;
  text-overflow: ellipsis;
  overflow: hidden;
}
.right_time {
  color: #999999;
  font-weight: 400;
  font-size: 14px;
  margin-right: 39px;
}
.page_down {
  display: flex;
  width: 100%;
  background: #ffffff;
  margin-top: 12px;
  padding-bottom: 20px;
}
.down_left {
  height: 100%;
  width: 626px;
  margin-left: 40px;
}
.down_right {
  height: 248px;
  width: 565px;
}
.down_text {
  margin-top: 21px;
}
.down_text ul {
  display: flex;
  justify-content: space-between;
  line-height: 26px;
}
.down_text ul :hover {
  color: #0a57f4;
}
.down_text ul a {
  color: #333333;
}
.down_con {
  font-size: 14px;
  color: #333333;
  font-weight: 400;
  width: 426px;
  white-space: nowrap;
  word-break: normal;
  text-overflow: ellipsis;
  overflow: hidden;
}
.down_time {
  margin-right: 40px;
  font-size: 14px;
  color: #999999;
  font-weight: 400;
}
.quick_entry {
  display: flex;
  width: 520px;
  /* position: relative; */
  left: 38px;
  justify-content: space-evenly;
}
.quick_entry a,
.quick_entry_item {
  text-decoration: none;
  color: inherit;
  display: block;
  text-align: center;
}
.quick_entry_icon {
  width: 150px;
  height: 92px;
  display: block;
  margin: 0 auto;
  transition: transform 0.25s ease;
}
.quick_entry_item:hover .quick_entry_icon {
  transform: translateY(-4px);
}
.quick_info {
  width: 150px;
  white-space: normal;
  font-size: 13px;
  color: #333333;
  margin: 17px auto 0;
}
.text {
  margin-top: 30px;
  margin-left: 40px;
}

.title1 {
  margin-top: 30px;
  margin-left: 30px;
}

.title2 {
  padding-top: 30px;
}
.title3 {
  text-align: center;
  padding-top: 27px;
  padding-bottom: 35px;
}
.page p {
  font-size: 16px;
  font-weight: bold;
  color: #42588e;
}
.page span {
  font-size: 14px;
  font-weight: bold;
  color: #42588e;
}
.more {
  float: right;
  color: #42588e;
  font-size: 12px;
  font-weight: 400;
}
.img_con {
  margin-top: 21px;
  margin-left: 43px;
  width: 546px;
  height: 292px;
  margin-bottom: 26px;
}
.img_con img {
  width: 546px;
  height: 292px;
}
#modal {
  bottom: 50px;
  width: 546px;
  height: 50px;
  background: #000000;
  opacity: 0.7;
  position: relative;
}
#modal_des {
  top: 12px;
  color: white;
  font-weight: 400;
  font-size: 16px;
  position: relative;
  left: 20px;
}
.circle {
  bottom: 78px;
  display: flex;
  transform: translateX(-50%);
  width: 243px;
  height: 8px;
  justify-content: space-evenly;
  position: relative;
  left: 405px;
}
.current {
  list-style: none;
  width: 26px;
  height: 8px;
  background: #42588e;
}
.box {
  list-style: none;
  width: 26px;
  height: 8px;
  background: #dadada;
  opacity: 0.9;
}

.title-title {
  width: 229px;
  height: 30px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.title-right :hover{
  cursor: pointer;
  color: #0a57f4;
}
.title-brief {
  width: 229px;
  height: 65px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 18px;
  margin-top: 12px;
}
._title {
  display: flex;
  margin-left: 50px;
  width: auto;
  margin-top: 12px;
}
._title1 {
  display: flex;
  margin-left: 50px;
  width: auto;
  margin-top: 12px;
}
.title-left1 {
  color: #0055d3;
  width: 76px;
  height: 11px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.title-left2 {
  width: 76px;
  height: 11px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.tit_name {
  width: 363px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-left: -20px;
  white-space:nowrap;
  text-overflow:ellipsis;
  overflow: hidden;
}
.tit_name:hover{
  color: #0055d3;
  cursor: pointer;
}
.tit_name1:hover{
  color: #0055d3;
  cursor: pointer;
}
.tit_time:hover{
  color: #0055d3;
  cursor: pointer;
}
.tit_time1:hover{
  color: #0055d3;
  cursor: pointer;
}
.tit_name1 {
  width: 423px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-left: -50px;
  white-space:nowrap;
  text-overflow:ellipsis;
  overflow: hidden;
}
.tit_time {
  width: 76px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-left: 57px;
}
.tit_time1 {
  width: 76px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-left: 76px;
}
.up_right_bottom{
  margin-top: 36px;
}
</style>